import { useState } from 'react'
import { useQuery } from 'react-query'

import { Buttons } from '@/components/common/buttons'
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from '@/components/ui/sheet'
import VistaProductSelector from '@/features/equipamentos/features/vista/components/vista-produto-selector'
import { ViewVistaDisplayer } from '@/features/equipamentos/features/vista/components/vista-displayer'
import { VistaService } from '@/features/equipamentos/services/vista.service'
import { Product } from '@/services/backend/config/entities'

import { ChamadoProdutoService } from '../../services/chamado-produto.service'

interface Props {
  callId: number
  equipmentId: string
  onChange: () => void
}

function VistaList({
  equipmentId,
  onSelectProduct,
}: {
  equipmentId: string
  onSelectProduct: (data: Product) => void
}) {
  const { data } = useQuery(
    ['CreateCallProductDialog', { equipmentId }],
    async () => {
      return await VistaService.findByEquipmentId({ equipmentId })
    },
  )

  const sortedData = (data || []).sort((a, b) => (a.name > b.name ? 1 : -1))

  return (
    <>
      {sortedData.map((ea) => (
        <div key={ea.id} className="mb-4 pr-4">
          <ViewVistaDisplayer data={ea}>
            <VistaProductSelector
              vistaId={ea.id}
              onSelect={(data) => onSelectProduct(data.Product)}
            />
          </ViewVistaDisplayer>
        </div>
      ))}
    </>
  )
}

export default function Component({ callId, equipmentId, onChange }: Props) {
  const [isOpen, setIsOpen] = useState(false)

  async function createHandler(data: Product) {
    try {
      await ChamadoProdutoService.create({ callId, productId: data.id })
      onChange()
    } catch {
      // Error toast is already shown by the API connector interceptor
    }
  }

  return (
    <Sheet open={isOpen} onOpenChange={setIsOpen}>
      <SheetTrigger asChild>
        <Buttons.Add />
      </SheetTrigger>

      <SheetContent className="w-full overflow-y-auto sm:max-w-xl">
        <SheetHeader>
          <SheetTitle>Selecione uma vista</SheetTitle>
        </SheetHeader>

        <div className="mt-4">
          <VistaList
            equipmentId={equipmentId}
            onSelectProduct={createHandler}
          />
        </div>
      </SheetContent>
    </Sheet>
  )
}
